<template>
  <div>
    <vs-table stripe search :data="listLeads" pagination max-items="15">
      <template slot="header">
        <h3>Leads:</h3>
      </template>

      <template slot="thead">
        <vs-th class="background" sort-key="idLead">ID</vs-th>
        <vs-th class="background" sort-key="nome">Nome</vs-th>
        <vs-th class="background" sort-key="celular">Celular</vs-th>
        <vs-th class="background" sort-key="origem">Origem</vs-th>
        <vs-th class="background" sort-key="placa">Placa</vs-th>
        <vs-th class="background" sort-key="cidade">UF/Cidade</vs-th>
        <vs-th class="background" sort-key="estado">Criação</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
          <vs-td
            >{{ tr.idLead }}
            <router-link
              v-if="tr.idProposta"
              target="_blank"
              :to="`/DetalheVistoria/${tr.idProposta}`"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                svgClasses="h-4 w-4"
              /> </router-link
          ></vs-td>
          <vs-td>{{ tr.nome }}</vs-td>
          <vs-td>{{ tr.celular }}</vs-td>
          <vs-td>{{ tr.origem }}</vs-td>
          <vs-td>{{ tr.placa }}</vs-td>
          <vs-td>{{ tr.estado }}/{{ tr.cidade }}</vs-td>
          <vs-td>{{ formataData(tr.createdAt) }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import notify from '../../../../utils/notify';
import leadsB2CService from '../Leads/service/index';
import moment from 'moment';

export default {
  data() {
    return {
      listLeads: [],
    };
  },
  methods: {
    async buscaLeadsB2C() {
      try {
        this.$vs.loading();
        this.listLeads = await leadsB2CService.getLeadsB2C();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    formataData(data) {
      // formats data received from API
      var formattedData = moment(data).format('DD/MM/YYYY');
      return formattedData;
    },
  },
  mounted() {
    this.buscaLeadsB2C();
  },
};
</script>
<style scoped>
.background {
  background: #a0dde133;
}
</style>
